import {
	defineExperimentalFeatures,
	type ExperimentalFeaturesProp,
} from '@atlassian/experimental-features';

const { withExperimentalFeatures, useExperimentalFeatures } = defineExperimentalFeatures({
	inviteFromAssignModal: {
		oneOf: ['control', 'not-enrolled', 'variation'],
		defaultValue: 'not-enrolled',
	},
	coreInvitesInJiraProjects: {
		oneOf: [
			'not-enrolled',
			'control',
			'invite-only-variation',
			'invite-only-not-enrolled',
			'invite-ra-variation',
			'invite-ra-not-enrolled',
		],
		defaultValue: 'not-enrolled',
	},
	/**
	 * @deprecated
	 * This prop has no imapct on the component - holdouts are done using Statsig now
	 */
	growthTeamHoldout: {
		oneOf: ['not-enrolled', 'control', 'variation'],
		defaultValue: 'not-enrolled',
	},
	// Describes if the user is eligible for the invite and assign from board experiment
	// but is enrolled in the control cohort.
	isEligibleForInviteAndAssignFromBoard: false,
	// Specifically for Xflow to Confluence - Onboarding Setup Screen
	// Enable to invite same-org users by either AAID or Emails via /gateway/api/v3/invitations/invite
	confluenceXflowOnboarding: false,
	// A Jira experiment that triggers core invite when a user inserted a link in a project
	// and more than 3 project members require access to the linked resource
	invitePromptOnLinkV3: false,
	// A Jira experiment to re-add the Invite button in the global Nav.
	// When active, it adds a Copy Link button.
	restoreInviteButton: false,
	// A Confluence experiment when active, it adds a Copy Link button to the invite modal for Confluece.
	showConfluenceCopyLink: false,
	// A Jira experiment to add the Invite button to side nav footer.
	sideNavInviteButton: false,
} as const);

/**
 * **Removing** your experimental feature?
 *   - Move it here to avoid a MAJOR bump.
 *
 * Doing a MAJOR bump?
 *   - **Clear** this back to `{} as const`.
 */
const LEGACY_FEATURES = {
	// Example of `LEGACY_FEATURES` usage:
	//
	// /**
	//  * This has been productionized and is always ON, regardless of the prop value.
	//  *
	//  * @deprecated
	//  */
	// sampleLegacyExperiment: {
	//   oneOf: ['control', 'not-enrolled', 'variation-1', 'variation-2'],
	//   defaultValue: 'not-enrolled',
	// },
} as const;

export type LegacyFeaturesProp = ExperimentalFeaturesProp<typeof LEGACY_FEATURES>;

export { withExperimentalFeatures, useExperimentalFeatures };
